import styled, { css } from 'styled-components';

import { colors, fontSizes } from '../../theme';
import RadioButton, { RadioButtonVariableNames } from '../RadioButton';

export const WizardRoot = styled.div(({ theme }) => {
  const variant = theme.components.Wizard.mode;

  return css`
    display: flex;
    box-sizing: border-box;
    flex-grow: 0;
    flex-shrink: 0;
    gap: ${variant.inside};
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: ${variant['vertical-padding']} ${variant['horizontal-padding']};
    background-color: ${variant.bg};
    color: ${variant.fg};
    overflow: auto;
  `;
});

export const Steps = styled.div`
  box-sizing: border-box;
  display: flex;
  flex: 1 1 auto;
  gap: ${({ theme }) => theme.components.Wizard.mode['step-stack']};
  align-items: center;
  justify-content: space-between;
  max-width: max-content;
`;

export const WizardRadioButton = styled(RadioButton)({
  [RadioButtonVariableNames.TransitionDuration]: '0ms',
});

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.components.Wizard.mode['step-inside']};
  align-items: flex-start;
`;

export const StepSubtitle = styled.span`
  color: ${({ theme }) => theme.components.Wizard.mode.label};
  font-size: ${fontSizes.xs};
`;

export const StepTitle = styled.span<{ $isActive: boolean }>`
  color: ${colors.navy};
  text-align: left;
  text-transform: capitalize;
  text-shadow: ${({ $isActive }) => $isActive && `0 0 0.3px ${colors.navy}`};
`;
